export default "__VITE_ASSET__BOXyCdsu__"